module.exports = __webpack_public_path__ + "fonts/39b26aa4bf55654469a99bc08e36c587.svg";